import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import DeleteIcon from "@material-ui/icons/Delete";

import { useStyles } from "../../../../Components/CSS/FormStyle.css";
import CustomDialogBox from "../../../../Components/CustomDialogBox/CustomDialogBox";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import FormLoader from "../../../../Components/FormLoader/FormLoader";

class SubjectBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      notificationOpen: false,
      subjectId: "",
      editStatus: false,
      data: {
        name: "",
      },
      subjectError: "",
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      data: {
        name: e.target.value,
      },
    });
  };

  handleDialogOpen = (subjectId) => {
    this.setState({
      dialogOpen: true,
      subjectId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  checkError = (subject) => {
    let subjectError = subject ? subject : "";

    if (subjectError) {
      this.setState({
        subjectError,
      });
      return false;
    } else {
      this.setState({
        subjectError: "",
      });
      return true;
    }
  };

  handleEditSubject = async (subjectId) => {
    this.setState({
      editStatus: true,
    });
    try {
      const response = await Axios.get(`${url}/api/subjects/${subjectId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.subject.length !== 0) {
        this.setState({
          subjectId,
          data: { name: response.data.subject.name },
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleEditSubject(subjectId);
      }
    }
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleDeleteStudent = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/subjects/${this.state.subjectId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Subject deleted successfully") {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getSubjects();
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteStudent();
      }
    }
  };

  handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      this.setState({ loading: true });
      const response = await Axios.put(
        `${url}/api/subjects/${this.state.subjectId}`,
        this.state.data,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Subject updated successfully") {
        this.setState({ loading: false });
        this.handleCancelEdit();
        this.props.getSubjects();
      }
    } catch (error) {
      this.setState({ loading: false });
      if (error.response.status === 409) {
        console.clear();
        this.checkError("Subject already stored");
      }
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleEditSubmit(e);
      }
    }
  };

  render() {
    const { classes, data, index } = this.props;
    return this.state.editStatus === false ? (
      <TableRow
        style={{
          backgroundColor: `${index % 2 ? "#fff" : "#eee"}`,
        }}
      >
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.name}</TableCell>

        <TableCell align="center">
          <Tooltip
            title="Edit"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleEditSubject(data._id)}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            title="Delete"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteStudent}
        />
      </TableRow>
    ) : (
      <TableRow>
        <TableCell />
        <TableCell align="center">
          <TextField
            name="name"
            type="text"
            label="Subject Name"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            error={this.state.subjectError ? true : false}
            helperText={
              this.state.subjectError
                ? this.state.subjectError
                : "E.g English or Nepali or Physics "
            }
            placeholder="Enter the name of subject"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.name}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          <Tooltip
            title="Update"
            arrow
            onClick={this.handleEditSubmit}
            className={classes.tooltip}
          >
            <CheckCircleIcon />
          </Tooltip>
          <Tooltip
            title="Cancel"
            arrow
            onClick={this.handleCancelEdit}
            className={classes.tooltip}
          >
            <CancelIcon />
          </Tooltip>
          {this.state.loading && <FormLoader />}
        </TableCell>
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(SubjectBody)));
